import { WAREHOUSE_ADDRESSES_ACTIONS } from './warehouseAddresses.types'

/**
 * @param {Object.<string, import('./warehouseAddresses.types').WarehouseAddress>} payload
 * @returns {Object}
 */
export const setWarehouseAddressesAction = payload => ({
  type: WAREHOUSE_ADDRESSES_ACTIONS.SET_WAREHOUSE_ADDRESSES,
  payload
})

/**
 * @param {import('./warehouseAddresses.types').WarehouseAddress} payload
 * @returns {Object}
 */
export const setWarehouseAddressAction = payload => ({
  type: WAREHOUSE_ADDRESSES_ACTIONS.SET_WAREHOUSE_ADDRESS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setWarehouseAddressesStatusAction = payload => ({
  type: WAREHOUSE_ADDRESSES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setWarehouseAddressesErrorsAction = payload => ({
  type: WAREHOUSE_ADDRESSES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearWarehouseAddressesErrorsAction = () => ({
  type: WAREHOUSE_ADDRESSES_ACTIONS.CLEAR_ERRORS
})
